import '../../UsersScreen/UserTable.css'
import React, { useEffect, useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { fetchEditUserExam, fetchExamScoreboard, fetchUsersExam } from '../ExamApi'
import ConfirmModal from '../../../components/_modals/ConfirmModal';
import { useSelector } from 'react-redux';
import { selectTranslations } from '../../../services/i18n/i18nSlice';
import { toast } from 'react-toastify';
import { mcsToTime } from '../../../utils/utils';

// Funzione per recuperare dati dall'API


const ScoreboardTable = (props) => {

    const t = useSelector(selectTranslations)

    const [data, setData] = useState([]);
    const [nextCursor, setNextCursor] = useState(null);
    const [previousCursor, setPreviousCursor] = useState(null);
    const [pageCount, setPageCount] = useState(1)
    const [loading, setLoading] = useState(false);
    const [currentCursor, setCurrentCursor] = useState(null);

    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "Elimina",
        closeCta: "Annulla"
    })

    const openResetmodal = (user_exam_id) => {
      if(user_exam_id){
        setConfirmModal({
                ...confirmModal,
                show:true,
                title: t.exam.delete_user_exam,
                text: t.exam.delete_user_exam_text,
                onClose: ()=>closeConfirmModal(),
                onConfirm: ()=>handleDeleteUserExam(user_exam_id)
            })
      }
    }

    const closeConfirmModal = () => {
      setConfirmModal({
        ...confirmModal,
        show: false,
        onConfirm: null
      })
    }

    const handleDeleteUserExam = async (user_exam_id) => {
      if(user_exam_id){
        try {
            // Sostituisci con il tuo endpoint API
            const response = await fetchEditUserExam(user_exam_id,{
                deleted: true
            })
            if(response.success){
              closeConfirmModal()
              toast.success("Tentativo eliminato")
              fetchAndSetData(currentCursor);
            }
        } catch (error) {
            toast.error(`Errore durante il recupero dei dati ${error}`)
            return null;
        }
      }
    }

    const fetchDataFromApi = async (cursor) => {
        try {
            // Sostituisci con il tuo endpoint API
            const response = await fetchExamScoreboard(props.examId,{
                limit: 15,
                start_cursor: cursor,
                sorting: 'descending'
            })
            return response.data;
        } catch (error) {
            console.error("Errore durante il recupero dei dati", error);
            return null;
        }
    };

    const columns = [
        // Colonna per accedere all'email dall'oggetto annidato "details"
        {
            accessorFn: (row) => row.user_data?.user_id,
            header: "ID Utente",
        },
        {
            accessorFn: (row) => row.position,
            header: "Posizione",
        },
        {
            accessorFn: (row) => row.user_data?.firstname,
            header: "Nome",
        },
        {
            accessorFn: (row) => row.user_data?.lastname,
            header: "Cognome",
        },
        {
            accessorFn: (row) => row.total_score,
            header: "Punteggio totale",
        },
        {
            accessorFn: (row) => row.precise_time_elapsed,
            header: "Tempo impiegato (microsec)",
        },
    ];

    const getRowStyle = (deleted) => {
      
        if (deleted) {
            return { backgroundColor: "red", color: "#fff" };
        } 
        return {}; // Default, nessuna colorazione
    };

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    const fetchAndSetData = async (cursor, action) => {
        setLoading(true);
        const response = await fetchDataFromApi(cursor);
        if (response) {
            setData(response.scoreboard);
            setNextCursor(response.next_data.cursor);
            setPreviousCursor(previousCursor ? cursor : null);
        }
        setLoading(false);
    };

    // Recupera i dati al montaggio del componente e quando cambia il cursore
    useEffect(() => {
        fetchAndSetData(currentCursor);
    }, [currentCursor]);

    const handleNext = () => {
        if (nextCursor) {
            setCurrentCursor(nextCursor);
            setPageCount(pageCount => pageCount + 1 )
        }
    };

    const handlePrevious = () => {
        if (previousCursor) {
            setCurrentCursor(previousCursor);
            setPageCount(pageCount => pageCount - 1 )
        } else {
            setCurrentCursor();
            setPageCount(pageCount => pageCount - 1 )
        }
    };

    useEffect(() => {
        fetchAndSetData();
    }, [props.examId]);

   return (
    <div className='userTable'> 
      {loading ? (
        <p>Caricamento...</p>
      ) : (
        <table>
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th key={header.id}>
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id}
                style={getRowStyle(row.original.deleted)}
              >
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div className='d-flex justify-content-between mt-3'>
        <button onClick={handlePrevious} disabled={!previousCursor && pageCount === 1}>
          Precedente
        </button>
        <button onClick={handleNext} disabled={!nextCursor}>
          Successivo
        </button>
      </div>

      <ConfirmModal props={confirmModal} />

    </div>
  );
};

export default ScoreboardTable;
